import { render, staticRenderFns } from "./RulesSupervisor.vue?vue&type=template&id=496559b9&scoped=true&"
import script from "./RulesSupervisor.vue?vue&type=script&lang=js&"
export * from "./RulesSupervisor.vue?vue&type=script&lang=js&"
import style0 from "./RulesSupervisor.vue?vue&type=style&index=0&id=496559b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496559b9",
  null
  
)

export default component.exports